import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { SERVICE_INITIAL_STATE, ACTION_INITIAL_STATE } from './options';
import calculateServiceState from './calculateServiceState';

var makeReducer = function makeReducer(serviceDeclaration, actionTypesForService) {
  var initialState = _objectSpread({}, SERVICE_INITIAL_STATE, {}, serviceDeclaration.actionsDeclarations.reduce(function (r, actionDeclaration) {
    return _objectSpread({}, r, _defineProperty({}, actionDeclaration.name, _objectSpread({}, ACTION_INITIAL_STATE)));
  }, {}));

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    if (!action) {
      // @TODO - log error in error reducer maybe
      return state;
    }

    var actionName = action && action.actionDeclaration && action.actionDeclaration.name;

    if (!actionName) {
      // @TODO - log error in error reducer maybe
      return state;
    } // certain reducer haven't to handle all actions
    // if action is not handle by this reducer, skip


    if (!actionTypesForService[actionName]) {
      // @TODO - log error in error reducer maybe
      return state;
    }

    var newActionState = null;

    switch (action.type) {
      case actionTypesForService[actionName].START_FETCHING:
        newActionState = _defineProperty({}, actionName, _objectSpread({}, state[actionName], {
          isLoading: true,
          isError: false,
          error: null,
          touched: action.timestamp
        }));
        return calculateServiceState(_objectSpread({}, state, {}, newActionState));

      case actionTypesForService[actionName].STOP_FETCHING:
        newActionState = _defineProperty({}, actionName, _objectSpread({}, state[actionName], {
          isLoading: false,
          touched: action.timestamp
        }));
        return calculateServiceState(_objectSpread({}, state, {}, newActionState));

      case actionTypesForService[actionName].RECEIVES_DATA:
        newActionState = _defineProperty({}, actionName, _objectSpread({}, state[actionName], {
          data: action.data,
          rawData: action.rawData,
          touched: action.timestamp
        }));
        return calculateServiceState(_objectSpread({}, state, {}, newActionState));

      case actionTypesForService[actionName].ERROR:
        newActionState = _defineProperty({}, actionName, _objectSpread({}, state[actionName], {
          isLoading: false,
          isError: true,
          error: action.data,
          touched: action.timestamp
        }));
        return calculateServiceState(_objectSpread({}, state, {}, newActionState));

      default:
        return state;
    }
  };
};

export default (function (servicesDeclarations, actionTypes) {
  return servicesDeclarations.reduce(function (r, serviceDeclaration, i) {
    return _objectSpread({}, r, _defineProperty({}, serviceDeclaration.name, makeReducer(serviceDeclaration, actionTypes[serviceDeclaration.name])));
  }, {});
});